import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';
import { reviewDataCuts } from '../../actions/MigrationSettingsActions';
import { Link } from 'react-router-dom';

class DataCutSettings extends Component {
  static propTypes = {
    reviewDataCuts: func,
    showDataCut: bool,
    setDataCutOption: func,
    dataCutOption: string,
    dataCutOptionsSaved: bool,
    noExceptions: bool
  };

  constructor(props) {
    super(props);
    this.onCheck = this.onCheck.bind(this);
    this.onReviewDataCuts = this.onReviewDataCuts.bind(this);
    this.onCheckAll = this.onCheckAll.bind(this);
    this.onCheckExceptions = this.onCheckExceptions.bind(this);
  }

  onCheck(option) {
    this.props.setDataCutOption(option);
  }

  onCheckAll() {
    this.onCheck('all');
  }

  onCheckExceptions() {
    this.onCheck('exceptions');
  }

  onReviewDataCuts() {
    const { reviewDataCuts } = this.props;
    reviewDataCuts();
    return false;
  }

  dataCutOptions() {
    const { showDataCut, dataCutOption } = this.props;
    const classes = ['survey-migration-settings__data-cut-options'];
    if (showDataCut) {
      classes.push('show');
    }

    return (
      <div className={classes.join(' ')}>
        <div className="survey-migration-settings__priority-headings">Apply Data Cut Priority to</div>
        <div className="survey-migration-settings__priority-headings">
          {/* Commented out for future implementation of setting data cuts
          <a onClick={this.onReviewDataCuts}>Review Data Cut Priority</a>*/}
        </div>
        <div
          onClick={this.onCheckExceptions}
          className={classNames('survey-migration-settings__priority-items', {
            active: dataCutOption === 'exceptions'
          })}
        >
          <i className="icon-check" />
          <h4 className="survey-migration-settings__priority--header">
            Exceptions due to missing data cuts in the new survey
          </h4>
          Auto migrate these matches using priority-based data cuts
        </div>
        <div
          onClick={this.onCheckAll}
          className={classNames('survey-migration-settings__priority-items', { active: dataCutOption === 'all' })}
        >
          <i className="icon-check" />
          <h4 className="survey-migration-settings__priority--header">All Matches</h4>
          Use priority-based data cuts to migrate all matches
        </div>
      </div>
    );
  }

  render() {
    const { showDataCut, dataCutOptionsSaved, noExceptions } = this.props;
    const noExceptionsText = 'The selected surveys are set up for their data cuts to be changed';
    const someExceptionsText = 'Some of the selected surveys have been set up for their data cuts to be changed';
    const exceptionsText = 'The selected surveys are not set up for their data cuts to be changed';
    const cardTitleClassnames = classNames('survey-migration-settings__heading pxl-header-xsmall', {
      options: !dataCutOptionsSaved
    });
    return (
      <ActionableHeaderCard
        className={classNames('survey-migration-settings__panel data_cuts ' + (showDataCut ? 'show' : ''), {
          'panel-bulk': !dataCutOptionsSaved
        })}
        cardTitle="Bulk fix data cut exceptions by data cut change"
        cardTitleClassName={cardTitleClassnames}
      >
        <p
          className={classNames('survey-migration-settings__subheading', {
            'subheading-bulk': !dataCutOptionsSaved
          })}
        >
          {this.renderSubHeading}
          {noExceptions && dataCutOptionsSaved
            ? `${noExceptionsText}`
            : !noExceptions && dataCutOptionsSaved
            ? `${someExceptionsText}`
            : `${exceptionsText}`}
          {dataCutOptionsSaved && (
            <Link target="_blank" to="/market-analysis/data-cut-migration/">
              Review data cut change
            </Link>
          )}
        </p>
        {this.dataCutOptions()}
      </ActionableHeaderCard>
    );
  }
}

export default DataCutSettings;
